import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-arrow",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.07,14.69c-.32,0-.56-.19-.56-.44,0-.12,.07-.26,.14-.36,.5-.66,1.02-1.31,1.53-1.97,.8-1.03,1.61-2.07,2.41-3.1,.17-.22,.34-.45,.52-.67,.09-.11,.1-.18,0-.3-.93-1.18-1.84-2.37-2.76-3.55-.56-.72-1.12-1.45-1.69-2.17-.2-.26-.21-.41-.05-.63,.14-.19,.4-.25,.65-.14,.64,.28,1.27,.56,1.91,.84,1.25,.56,2.5,1.12,3.76,1.68,1.08,.48,2.16,.96,3.23,1.44,1.66,.74,3.32,1.48,4.98,2.22,.21,.09,.35,.24,.36,.46,0,.22-.14,.38-.35,.47-1.07,.47-2.14,.95-3.21,1.42-1.48,.66-2.95,1.32-4.43,1.97-1.42,.63-2.84,1.26-4.25,1.89-.67,.3-1.33,.59-2,.88-.08,.03-.16,.04-.2,.05Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}